/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_ResidenceStatusDto } from '../models/PagedResultDto_ResidenceStatusDto';
import type { Wealthlane_CustomerService_Dtos_ResidenceStatus_CreateUpdateResidenceStatusDto } from '../models/Wealthlane_CustomerService_Dtos_ResidenceStatus_CreateUpdateResidenceStatusDto';
import type { Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto } from '../models/Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ResidenceStatusService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppResidenceStatusResidenceStatusList(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/residence-status/residence-status-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppResidenceStatus(
        requestBody?: Wealthlane_CustomerService_Dtos_ResidenceStatus_CreateUpdateResidenceStatusDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/residence-status',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_ResidenceStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppResidenceStatus(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_ResidenceStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/residence-status',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppResidenceStatus(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_ResidenceStatus_CreateUpdateResidenceStatusDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/residence-status/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppResidenceStatus(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/residence-status/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppResidenceStatus1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_ResidenceStatus_ResidenceStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/residence-status/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
